import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getItems } from "../../redux/actions/actionItem";
import ItemsCard from "./itemsCard";
import LoadingIcons from "react-loading-icons";

export default function Items(){
    const items = useSelector((state)=> state.items.allItems);
    const dispatch = useDispatch();
    const [itemFind, setItemFind] = useState();
    const [itemInput, setItemInput] = useState("")


    useEffect(() => {
        dispatch(getItems())
    }, [dispatch])

    console.log(items)

    const handleChange = (e) => {
        const { value } = e.target
        setItemInput(value)
      }
  
      const filterItem = () => {
         console.log(itemInput);
          if (itemFind === undefined) {
            let result = items.filter((e) => {
              if (
                e.name
                  .toString()
                  .toLowerCase()
                  .includes(itemInput.toLowerCase())
                  ) {
                //console.log(e)
                return e;
              }
            });
            setItemFind(result);
          } else {
            let result = itemFind.filter((e) => {
              if (
                e.name
                .toString()
                .toLowerCase()
                .includes(itemInput.toLowerCase())
                ) {
                  //console.log(e)
                  return e;
                }
              });
              setItemFind(result);
            }
          };
  
          const handleLimpiar = () => {
            console.log(itemFind);
            setItemFind(items)
          }
         

    return (
        <div className="min-w-full bg-gray-900">
            <div className="m-5">
            <div>
                <p className="text-xl pb-8 underline  text-orange-500">Informes - Articulos</p>
            </div>
            <div className="h-20 bg-cyan-900">
            <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="text"
              placeholder="Articulo"
              onChange={handleChange}
              
            />
          </div>
          <div className="w-56 text-center">
            <button className="w-16 ml-14 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={filterItem}>Buscar</button>
            <button className="w-16 h-6 ml-2 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={handleLimpiar}>Limpiar</button>
          </div>
            </div>
            <div className="">
                <div className="flex flex-row  text-orange-500">
                    <div className="mb-2 w-12 text-[14px] font-bold text-center">N° Item</div>
                    <div className="mb-2 w-60 text-[14px] font-bold text-left pl-2">Nombre</div>
                    <div className="mb-2 w-6/12 text-[14px] font-bold text-left ">Descripcion</div>
                    <div className="mb-2 w-14 text-[14px] font-bold text-center">Stock</div>
                    <div className="mb-2 w-14 text-[14px] font-bold text-center">Stock Total</div>
                    <div className="mb-2 w-14 text-[14px] font-bold text-center">Res</div>
                    {/* <div className="w-30">Eliminar</div> */}
                </div>
                {items.length === 0 ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> :
                itemFind === undefined ?
                items.map(e=> (
                    <ItemsCard
                    key={e._id}
                    id={e._id}
                    idItem={e.idItem}
                    name={e.name}
                    description={e.description}
                    stock={e.stock}
                    stockTotal={e.stockTotal}
                    />
                ))
            :
            itemFind.map(e=> (
                <ItemsCard
                key={e._id}
                id={e._id}
                idItem={e.idItem}
                name={e.name}
                description={e.description}
                stock={e.stock}
                stockTotal={e.stockTotal}
                />
            ))
            }
            </div>
            </div>
        </div>
    )
}